import { DuplicateCustomerEngagementPlanning } from 'basics/graphql/mutations/duplicateCep';
import { MutationReturnType } from 'basics/types/maya.types';
import { CustomerEngagementPlanning } from 'generated/maya.types';

export type CepFormSubmitCallbackType = (
  cep: Partial<CustomerEngagementPlanning>
) => Promise<MutationReturnType<CustomerEngagementPlanning>>;

export type DuplicateTacticAndTargetsFromEvent = (
  customerEngagementPlanningData: DuplicateCustomerEngagementPlanning
) => Promise<void>;

export type CepFormPropsType = {
  submitCallback: CepFormSubmitCallbackType;
  isTemplate: boolean;
};

export enum CepFormStepsIndex {
  configurationStep = 0,
  targetListStep = 1,
  tacticsStep = 2,
  goalStep = 3,
  miViewPreviewStep = 4,
}
